function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.79 87.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "43.9 29.02 29.02 43.9 43.9 58.77",
    style: {
      fill: "none",
      stroke: "#414141",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "3.72px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.02,
    y1: 43.9,
    x2: 58.77,
    y2: 43.9,
    style: {
      fill: "none",
      stroke: "#414141",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "3.72px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.4be305961b74818b6573c4d8b754c9af.svg";
export { ForwardRef as ReactComponent };